import c from "../Constants";
// require('es6-promise').polyfill();
require('isomorphic-fetch');

var promociones = {

    getAll() {

        let defaultOptions = {
            url: '',
            method: 'GET',
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
                "Content-Type": "application/json;charset=UTF-8",
            },
            // cache: false,
            dataType: 'json',
        };
        return fetch(c.BASE_URL + '/api/promociones', defaultOptions);
    },

};

export default promociones;


// WEBPACK FOOTER //
// ./src/api/promociones.js